import { useRouter } from "next/router";
import { useMemo } from "react";
import { FederatedRedirectOptions } from "src/contexts/AuthProvider";
import { getRedirectParams } from "src/libs/urlLib";

// builds federatedRedirectOptions using a provided value or the redirect query
// params
export function useFederatedRedirectOptions(
  federatedRedirectOptionsInitial?: FederatedRedirectOptions
): FederatedRedirectOptions | undefined {
  const router = useRouter();

  const { upgradeFromUrl, redirectUrl } = getRedirectParams(router.query);

  return useMemo(() => {
    if (federatedRedirectOptionsInitial) {
      return federatedRedirectOptionsInitial;
    } else if (redirectUrl) {
      return {
        upgradeFromUrl,
        redirectUrl,
      };
    } else {
      return undefined;
    }
  }, [federatedRedirectOptionsInitial, upgradeFromUrl, redirectUrl]);
}
